import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import {
    Button, Input,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";

import ShowDetails from 'components/ShowDetails';
import AGenerateModel from 'components/generic/AGenerateModel';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import { withRouter } from 'components/withRouter';

class ManageServices extends Component {
    static displayName = ManageServices.name;

    static serviceSchema;
    static serviceModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    constructor(props) {
        super(props);

        this.serviceGen = React.createRef(null);
        this.jsonGen = React.createRef(null);

        this.state = { services: [], curService: null, curServiceId: 0, loading: true, dataStamp: 0, activeTab: "1", title: props.i18nManager.t("service.noSelected"), editionMode: false, jsonModel: null };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            //commonFunc.getMethod("../api/service/GetServiceModels", { id: -1, categ: "SERVICES" }).then((responseModels) => {
            //commonFunc.getMethod("../api/service/GetServiceModelsList", { id: -1, categ: "SERVICES" }).then((responseModels) => {
            commonFunc.getMethod("../api/data/GetAllModels", { filter: "site", categ: "PARAMS", useParentSite: true, excludeMode: 1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {
                    commonFunc.getMethod("../api/data/GetAllModels", { filter: "report", useParentSite: true }).then((responseReportModels) => {
                        var dataRptModels = responseReportModels.data;
                        if (dataRptModels.isSuccess) {
                            context.serviceModels = {};
                            //dataModels.result?.forEach((model) => {//dataModels.result.models
                            dataModels.result?.map(keyItem => keyItem.tag).forEach((model) => {//dataModels.result.models
                                context.serviceModels[model.extID] = JSON.parse(model.value);
                            });
                            dataRptModels.result?.map(keyItem => keyItem.tag).forEach((model) => {//dataModels.result.models
                                context.serviceModels[model.extID] = JSON.parse(model.value);
                            });
                            /*commonFunc.getMethod("../api/service/GetSchemaModel", null).then((response) => {
                                var dataSchema = response.data
                                if (dataSchema.isSuccess) {

                                    context.serviceSchema = dataSchema.result;*/

                                    //Chargement via url
                                    var defServiceLoadId = 0;
                                    var defServiceActionId = 0;
                                    if (context.props.searchParams) {
                                        defServiceLoadId = parseInt(context.props.searchParams.get("serviceId")) || 0;
                                        defServiceActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                                    }
                                    if (defServiceLoadId === -1) defServiceLoadId = curUser.groupSId;
                                    if (defServiceLoadId > 0) {
                                        context.getServices(0, false, function () {
                                            if (context) {
                                                context.loadReportCb = () => {
                                                    if (defServiceActionId) context.switchTab(defServiceActionId.toString());

                                                    //setTimeout(function () {
                                                    var element = document.querySelector('.tableContainer');
                                                    const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                                    context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                                    //}, 2000);
                                                };
                                            }
                                            showDtSelID("tableServices", defServiceLoadId);
                                        });
                                    } else {
                                        context.getServices();

                                        if (defServiceActionId) context.switchTab(defServiceActionId.toString());
                                    }

                                /*}
                                else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Erreur",
                                        html: "Erreur lors de la récupération du schéma service"
                                    });
                                }
                            });*/
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: context.props.i18nManager.t("gal_fail"),
                                html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataRptModels.errorMessage
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateService
        if (this.state.curServiceId === 0 /*&& prevState.curServiceId !== this.state.curServiceId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableServices"]) this.dtFunctions["tableServices"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        //TEMP : doit dépendre d'une configuration (tout virer sauf createdCell et cbInitComplete)
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadService(rowData.idService, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                }
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idService;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadService(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadService();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
            <div>
                {this.serviceModels ? <CDataTable key="services" dtId={"tableServices"} data={this.state.services} localConfig={dtConfig} tag={"DT_SVCS"} config={this.serviceModels["DT_SVCS"]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
            </div>;

        var jsonTemplates = this.state.curService?.templates?.filter(template => !template.isHtml);
        var htmlTemplates = this.state.curService?.templates?.filter(template => template.isHtml);

        var jsonConfig;
        var htmlConfig;
        if (this.serviceModels) {
            jsonConfig = this.serviceModels[this.state.jsonModel];
            htmlConfig = this.serviceModels[this.state.htmlModel];
        }
        console.debug(this.serviceModels);

        return (
            <div className="tableDetails">
                <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                    <CardHeader>
                        <CardTitle tag="h6">{context.props.i18nManager.t("service.title")}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-table-list fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="float-start">
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getServices()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {this.props.checkRights("PARAMS", "C") ? <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateService()}>
                                <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("service.add")}
                            </Button> : ""}
                        </div>
                        {contents}
                    </CardBody>
                </Card>

                {this.state.isShowDetails ? (<div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                                <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curServiceId || 0;
                                        showDtPrevID("tableServices", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curServiceId || 0;
                                        showDtNextID("tableServices", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                {this.props.checkRights("SERVICE", "R") ? <NavItem><NavLink className={`${this.state.activeTab === '1' ? "active" : ""}`} onClick={() => { this.switchTab("1") }}>{context.props.i18nManager.t("service.tabDetails")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("REPORT_MODELS", "L") ? <NavItem><NavLink className={`${this.state.activeTab === '2' ? "active" : ""}`} onClick={() => { this.switchTab("2") }}>{context.props.i18nManager.t("service.tabJsonModel")}</NavLink></NavItem> : ""}
                                {this.props.checkRights("REPORT_MODELS", "L") ? <NavItem><NavLink className={`${this.state.activeTab === '3' ? "active" : ""}`} onClick={() => { this.switchTab("3") }}>{context.props.i18nManager.t("service.tabHtmlModel")}</NavLink></NavItem> : ""}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {this.props.checkRights("SERVICE", "R") ? <TabPane tabId="1">
                            <ShowDetails id={this.state.curServiceId} type="service" genRef={this.serviceGen} data={this.state.curService} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.serviceModels ? this.serviceModels["SERVICE"] : {}} modelsList={this.serviceModels} loadElem={(id) => {
                                //if (this.state.curServiceId !== id) {
                                    return this.getServices(0, false, function () {
                                        console.debug("TEST0");
                                        showDtSelID("tableServices", id);
                                    })
                                /*}
                                else {
                                    return this.loadService(id);
                                }*/
                            }} saveElem={this.saveService.bind(this)} removeElem={this.removeService.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === '1'} />
                        </TabPane> : ""}
                        {this.props.checkRights("REPORT_MODELS", "L") ? <TabPane tabId="2">
                            {jsonTemplates?.length ? <div className="d-inline-block">
                                {<>
                                    <label className="text-start control-label fw-bold ms-3">Modèle :</label>
                                    <Input className="w-auto d-inline-block mx-1 mb-2" name="jsonModel" type="select"
                                        value={this.state.jsonModel} onChange={(e) => {
                                            var value = e.target.value;

                                            var currTemplate = jsonTemplates.filter(template => template.extID === value);
                                            if (currTemplate.length)
                                                context.setState({ jsonModel: currTemplate[0].extID });
                                        }}>
                                        {jsonTemplates.map((dt, index) => {
                                            return (<option key={index} value={dt.extID}>{dt.name}</option>);
                                        })}
                                    </Input>
                                </>}
                            </div> : <div className="d-inline-block me-2">Aucun templates</div>}
                            {this.props.checkRights("PARAMS", "C") ? <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => { /*TODO*/ }}>
                                <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("service.addTemplate")}
                            </Button> : ""}
                            {this.state.jsonModel && this.props.checkRights("PARAMS", "U") ? <Button className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="primary" size="sm" onClick={() => { /*TODO*/ }}>
                                <i className="fa fa-edit"></i>{context.props.i18nManager.t("service.updTemplate")}
                            </Button> : ""}
                            {jsonTemplates?.length ? <div className="jsonModel editor-model">
                                <div className="alt-display-pic" style={{ backgroundImage: `url(${require("assets/img/res/tablet-frame.png")})` }}>
                                    {jsonConfig ? <AGenerateModel key={this.state.jsonModel} ref={this.props.jsonGen} parentProps={{ type: "model", dataCfg: this.props.dataCfg }} noButtons modelsList={this.serviceModels} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} getUser={this.props.getUser} configModel={jsonConfig} /> : ""}
                                </div>
                            </div> : ""}
                        </TabPane> : ""}
                        {this.props.checkRights("REPORT_MODELS", "L") ? <TabPane tabId="3">
                            {htmlTemplates?.length ? <div>
                                {<>
                                    <label className="text-start control-label fw-bold ms-3">Modèle :</label>
                                    <Input className="w-auto d-inline-block mx-1 mb-2" name="htmlModel" type="select"
                                        value={this.state.htmlModel} onChange={(e) => {
                                            var value = e.target.value;

                                            var currTemplate = htmlTemplates.filter(template => template.extID === value);
                                            if (currTemplate.length)
                                                context.setState({ htmlModel: currTemplate[0].extID });
                                        }}>
                                        {htmlTemplates.map((dt, index) => {
                                            return (<option key={index} value={dt.extID}>{dt.name}</option>);
                                        })}
                                    </Input>
                                </>}
                                <div className="jsonModel">
                                    {false && htmlConfig ? <AGenerateModel key={this.state.htmlModel} ref={this.props.jsonGen} parentProps={{ type: "model", dataCfg: this.props.dataCfg }} noButtons modelsList={this.serviceModels} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} getUser={this.props.getUser} configModel={htmlConfig} /> : ""}
                                </div>
                            </div> : "Aucun templates"}
                        </TabPane> : ""}
                    </TabContent></div>) : ""}
            </div>
        );
    }

    async getServices(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ services: [], curServiceId: 0, curService: {}/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        commonFunc.getMethod("../api/site/GetSiteServices", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {

                    /*$('#lstActs thead th').each(function () {
                        var title = $(this).text();
                        if ($(this).hasClass("searchable")) {
                            $(this).append('<input type="text" class="form-control col-lg-12 form-control-sm" placeholder="' + title + '" />');
                        }
                    });*/

                    Swal.close();
                    context.setState({ services: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("service.failLoadServices") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("service.failLoadServices")
                });
            }
        });

    }

    async loadService(id) {
        var context = this;

        var callback = this.loadReportCb;

        context.setState({ title: context.props.i18nManager.t("service.noSelected"), curServiceId: 0, curService: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;
            if (parseInt(id) > 0 && context.state.services.length) {
                this.loadReportCb = null;

                //Timeout pour forcé le rerender sans Détails pour actualiser AGenerateModel
                setTimeout(() => {
                    var svcFiltered = context.state.services.filter(svc => svc.idService === parseInt(id));
                    if (svcFiltered.length) {
                        var svc = svcFiltered[0];

                        if (callback && typeof (callback) === "function") { callback(svc); }

                        var jsonModelSvc = svc?.templates?.length ? svc?.templates.filter(template => !template.isHtml) : null;
                        if (jsonModelSvc?.length) jsonModelSvc = jsonModelSvc[0].extID;
                        var htmlModelSvc = svc?.templates?.length ? svc?.templates.filter(template => template.isHtml) : null;
                        if (htmlModelSvc?.length) htmlModelSvc = htmlModelSvc[0].extID;
                        context.setState({ title: (svc.name + " (" + svc.categ + ")  •  " + (svc.parent?.name || "")), curServiceId: id, curService: svc, isShowDetails: true, editionMode: false, jsonModel: jsonModelSvc, htmlModel: htmlModelSvc });

                        resolve(svc);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("service.failLoadService")
                        });
                        resolve({ isSuccess: false, result: context.props.i18nManager.t("service.failLoadService") });
                    }
                }, 100);
            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async saveService(userService, isUpdate) {
        var context = this;
        const dataService = this.state.curService || {};

        if (!(userService.refExtID || userService.parentID > 0)) {

            Swal.fire({
                title: context.props.i18nManager.t("gal_saving"),
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            if (isUpdate) {
                userService.dSysCreat = dataService.dSysCreat;
            }
            else {
                userService.dSysCreat = new Date();
            }

            if (userService.extras && userService.extras.length) {
                userService.extras.forEach((value, index) => {
                    value.extraServiceID = userService.idService;
                });
            }


            if (!userService.avoidMerge) {
                userService = commonFunc.mergeDeep({}, dataService, userService);

                /*userService.contacts = null;
                userService.files = null;
                userService.filesService = null;
                userService.groups = null;
                userService.models = null;*/
                userService.parent = null;
            }

            if (userService.groups?.length) {
                userService.groups.forEach((group, index) => {
                    if (group.groupServiceID !== userService.idService) {
                        group.idSegment = 0;
                        group.groupServiceID = userService.idService;
                    }
                });
            }

            console.debug(userService);
            //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
            return commonFunc.postMethod(isUpdate ? "../api/site/UpdateSiteService" : "../api/site/CreateSiteService", userService).then((response) => {
                Swal.close();
                return new Promise((resolve, reject) => {
                    var data = response.data;
                    if (data && data.isSuccess) {
                        Swal.fire({
                            icon: "success",
                            title: context.props.i18nManager.t("gal_success"),
                            html: (isUpdate ? context.props.i18nManager.t("gal_successUpd") : context.props.i18nManager.t("gal_successAdd")),
                            didOpen: () => { Swal.hideLoading() },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                        }).then((result) => {
                            /*context.getServices(0, true, () => {
                                showDtSelID("tableServices", data.result.idService);
                            });*/
                            context.loadService(data.result.idService);//userService.idService
                        });

                        data.result.idResponse = data.result.idService;
                        resolve(data.result);

                    } else {
                        var supErrors = "";
                        if (data.errors && data.errors.length) {
                            supErrors = data.errors.map((error) => {
                                return "<br>" + error.desc + "(" + error.value + ")";
                            });
                        }
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_fail"),
                            html: context.props.i18nManager.t("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                        });
                        resolve(data);
                    }
                });
            });
        }
        else {
            Swal.fire({
                icon: "error",
                title: context.props.i18nManager.t("gal_fail"),
                html: "Modification impossible"
            });
            context.loadService(context.state.curServiceId);
        }
    }

    removeService(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curService;
            if ((!id && row) || (id && row && id === row.idService)) {
                id = id || row.idService;
                title = row.name + " " + row.firstName;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t("service.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("service.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        commonFunc.postMethod("../api/site/RemoveSiteService", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getServices();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    initCreateService() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableServices");
        //this.serviceGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("service.create"), curServiceId: 0, curService: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;
        this.setState({ activeTab: numTab })
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curService ? (this.state.curService.name + " " + this.state.curService.firstName) : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("service.duplicate") : this.props.i18nManager.t("service.edit"))  + " - " + title, editionMode: value });
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageServices));
